var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDeleteRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52637 7.64428C2.52637 8.19656 2.97408 8.64427 3.52637 8.64427H3.87975V20.0522C3.87975 20.7641 4.16493 21.4468 4.67254 21.9502C5.18016 22.4536 5.86864 22.7364 6.58652 22.7364H17.4136C18.1315 22.7364 18.8199 22.4536 19.3276 21.9502C19.8352 21.4468 20.1204 20.7641 20.1204 20.0522V8.64427H20.4737C21.026 8.64427 21.4737 8.19656 21.4737 7.64427V6.96006C21.4737 6.40778 21.026 5.96006 20.4737 5.96006H16.7369V3.94691C16.7369 3.23501 16.4517 2.55227 15.9441 2.04888C15.4365 1.5455 14.748 1.2627 14.0301 1.2627H9.96998C9.2521 1.2627 8.56362 1.5455 8.056 2.04888C7.54839 2.55227 7.26321 3.23501 7.26321 3.94691V5.96006H3.52637C2.97408 5.96006 2.52637 6.40778 2.52637 6.96006V7.64428ZM17.4136 20.0522H6.58652V8.64427H17.4136V20.0522ZM9.96998 3.94691H14.0301V5.96006H9.96998V3.94691Z",
    fill: "#E04F50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteRed);
export default __webpack_public_path__ + "static/media/icon_delete_red.ff48cf879696e8eb3eb7764e483b1d78.svg";
export { ForwardRef as ReactComponent };